import { Flex } from "../../Flex"
import { Text, LargeText } from "../../Typography"
import * as styles from "./underSemiDonutStyles"

export type UnderSemiDonutProps = {
  value: string
  label: string
}

export const UnderSemiDonut = ({ value, label }: UnderSemiDonutProps) => (
  <Flex flexDirection="column" css={styles.root}>
    <Text css={styles.label}>{label}</Text>
    <LargeText>{value}</LargeText>
  </Flex>
)
